export enum Mode {
  Whitelist = "Whitelist",
  Countdown = "Countdown",
  Info = "Info",
  Verse = "Verse",
  Mint = "Mint",
}
